"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  KeyLock: ['key-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 20.250 A3.000 3.000 0 1 0 6.750 20.250 A3.000 3.000 0 1 0 0.750 20.250 Z', 'M6.75 20.25L14.25 20.25 14.25 22.5', 'M11.25 20.25L11.25 21.75', 'M6.75,15V11.25a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5v10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5', 'M9.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M15 14.25L15 17.25']],
  KeyholeSquare: ['keyhole-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M9.750 9.750 A2.250 2.250 0 1 0 14.250 9.750 A2.250 2.250 0 1 0 9.750 9.750 Z', 'M12 12L12 16.5']],
  DoorLock: ['door-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 9.750 L11.250 9.750 L11.250 18.750 L0.750 18.750 Z', 'M6,13.875a.375.375,0,1,0,.375.375A.374.374,0,0,0,6,13.875H6', 'M2.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75', 'M9.75,21.75a1.5,1.5,0,0,0,1.5,1.5h10.5a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H11.25a1.5,1.5,0,0,0-1.5,1.5']],
  Lock1: ['lock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 9.750 L20.250 9.750 L20.250 23.250 L3.750 23.250 Z', 'M6.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M12 15L12 18']],
  Lock: ['lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,13.875a.375.375,0,1,0,.375.375A.374.374,0,0,0,12,13.875h0', 'M15.75,9.75V7.5A3.76,3.76,0,0,0,12,3.75h0A3.761,3.761,0,0,0,8.25,7.5V9.75', 'M.75,3.75V2.25A1.5,1.5,0,0,1,2.25.75h1.5', 'M23.25,3.75V2.25a1.5,1.5,0,0,0-1.5-1.5h-1.5', 'M.75,20.25v1.5a1.5,1.5,0,0,0,1.5,1.5h1.5', 'M23.25,20.25v1.5a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M6.750 9.750 L17.250 9.750 L17.250 18.750 L6.750 18.750 Z']],
  HandGiveLock: ['hand-give-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.250 5.250 L23.250 5.250 L23.250 12.750 L14.250 12.750 Z', 'M18.75.75h0a3,3,0,0,0-3,3v1.5h6V3.75A3,3,0,0,0,18.75.75Z', 'M18.75,8.654a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75']],
  Lock7: ['lock-7', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 17.250 L18.750 17.250 L18.750 23.250 L0.750 23.250 Z', 'M23.25,20.25a1.5,1.5,0,0,1-1.5,1.5h-3v-3h3A1.5,1.5,0,0,1,23.25,20.25Z', 'M3.75,14.25V6.75a6,6,0,0,1,12,0v7.5']],
  Lock5: ['lock-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 15.000 A8.250 8.250 0 1 0 20.250 15.000 A8.250 8.250 0 1 0 3.750 15.000 Z', 'M9.750 15.000 A2.250 2.250 0 1 0 14.250 15.000 A2.250 2.250 0 1 0 9.750 15.000 Z', 'M6.75,8.635V6a5.25,5.25,0,0,1,10.5,0V8.635']],
  LockCircle: ['lock-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M6.750 9.750 L17.250 9.750 L17.250 18.750 L6.750 18.750 Z', 'M8.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M12 12.75L12 15.75']],
  Lock6: ['lock-6', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 9.750 L20.250 9.750 L20.250 23.250 L3.750 23.250 Z', 'M6.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M9.750 16.500 A2.250 2.250 0 1 0 14.250 16.500 A2.250 2.250 0 1 0 9.750 16.500 Z']],
  Lock8: ['lock-8', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,20.25a3,3,0,0,1-3,3h-12a3,3,0,0,1-3-3v-9a3,3,0,0,1,3-3h12a3,3,0,0,1,3,3', 'M6.75,8.25v-3a4.5,4.5,0,0,1,9,0v3', 'M15.75 14.25L21.75 14.25', 'M15.75 17.25L21.75 17.25']],
  LockCircle1: ['lock-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 9.750 L17.250 9.750 L17.250 18.750 L6.750 18.750 Z', 'M12,13.875a.375.375,0,1,0,.375.375A.374.374,0,0,0,12,13.875h0', 'M8.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  LockUnlock: ['lock-unlock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M6.750 9.750 L23.250 9.750 L23.250 23.250 L6.750 23.250 Z', 'M15 15L15 18']],
  LockUnlock1: ['lock-unlock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M6.750 9.750 L23.250 9.750 L23.250 23.250 L6.750 23.250 Z', 'M15,15.75a.375.375,0,1,0,.375.375A.374.374,0,0,0,15,15.75h0']],
  LockPassword: ['lock-password', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 9.750 L20.250 9.750 L20.250 23.250 L3.750 23.250 Z', 'M6.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M8.625,14.25A.375.375,0,1,0,9,14.625a.375.375,0,0,0-.375-.375h0', 'M12,14.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,14.25h0', 'M15.375,14.25a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M8.625,18A.375.375,0,1,0,9,18.375.375.375,0,0,0,8.625,18h0', 'M12,18a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,18h0', 'M15.375,18a.375.375,0,1,0,.375.375A.375.375,0,0,0,15.375,18h0']],
  LockUnlock2: ['lock-unlock-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M6.750 15.000 A8.250 8.250 0 1 0 23.250 15.000 A8.250 8.250 0 1 0 6.750 15.000 Z', 'M.75,9.75V5.25a4.5,4.5,0,0,1,9,0V8.635', 'M15 13.5L15 16.5']],
  LockHierarchy: ['lock-hierarchy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 21.000 A2.250 2.250 0 1 0 5.250 21.000 A2.250 2.250 0 1 0 0.750 21.000 Z', 'M9.750 21.000 A2.250 2.250 0 1 0 14.250 21.000 A2.250 2.250 0 1 0 9.750 21.000 Z', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M7.500 6.000 L16.500 6.000 L16.500 12.750 L7.500 12.750 Z', 'M12 18.75L12 12.75', 'M3 18.75L3 15.75 21 15.75 21 18.75', 'M9,6V3.75a3,3,0,0,1,6,0V6']],
  LockUnlock3: ['lock-unlock-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 15.000 A8.250 8.250 0 1 0 23.250 15.000 A8.250 8.250 0 1 0 6.750 15.000 Z', 'M12.750 15.000 A2.250 2.250 0 1 0 17.250 15.000 A2.250 2.250 0 1 0 12.750 15.000 Z', 'M.75,9.75V5.25a4.5,4.5,0,0,1,9,0V8.635']],
  TouchFingerLock: ['touch-finger-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,23.25l-2.929-2.344a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068l1.174.588V13.5a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v3l1.993.332a3,3,0,0,1,2.507,2.959V23.25', 'M8.25,10.875a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M3.750 8.250 L12.750 8.250 L12.750 14.250 L3.750 14.250 Z', 'M5.25,8.25V6.75a3,3,0,0,1,6,0v1.5', 'M8.25,17.25h-6a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h12a1.5,1.5,0,0,1,1.5,1.5v6']],
  LockUnlock4: ['lock-unlock-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M6.750 9.750 L23.250 9.750 L23.250 23.250 L6.750 23.250 Z', 'M12.750 16.500 A2.250 2.250 0 1 0 17.250 16.500 A2.250 2.250 0 1 0 12.750 16.500 Z']],
  Lock4: ['lock-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }], ['M3.750 15.000 A8.250 8.250 0 1 0 20.250 15.000 A8.250 8.250 0 1 0 3.750 15.000 Z', 'M6.75,8.635V6a5.25,5.25,0,0,1,10.5,0V8.635', 'M12 13.5L12 16.5']],
  Lock3: ['lock-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 15.000 A8.250 8.250 0 1 0 20.250 15.000 A8.250 8.250 0 1 0 3.750 15.000 Z', 'M12 10.5L12 12.75', 'M12 17.25L12 19.5', 'M16.5 15L14.25 15', 'M9.75 15L7.5 15', 'M9.750 15.000 A2.250 2.250 0 1 0 14.250 15.000 A2.250 2.250 0 1 0 9.750 15.000 Z', 'M6.75,8.635V6a5.25,5.25,0,0,1,10.5,0V8.635']],
  Lock2: ['lock-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 9.750 L20.250 9.750 L20.250 23.250 L3.750 23.250 Z', 'M6.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M12,15.75a.375.375,0,1,0,.375.375A.374.374,0,0,0,12,15.75h0']],
  LockShield: ['lock-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 9.750 L17.250 9.750 L17.250 17.250 L6.750 17.250 Z', 'M12,13.125a.375.375,0,1,0,.375.375A.374.374,0,0,0,12,13.125h0', 'M8.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75', 'M12,23.25C5.324,21.469.75,17.51.75,10.5V.75h22.5V10.5C23.25,17.505,18.683,21.467,12,23.25Z']],
  DoorPasswordLock: ['door-password-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.25,18.75a4.5,4.5,0,0,1-4.5,4.5H5.25a4.5,4.5,0,0,1-4.5-4.5V5.25A4.5,4.5,0,0,1,5.25.75h4.5a4.5,4.5,0,0,1,4.5,4.5v9', 'M0.75 5.25L14.25 5.25', 'M0.75 11.25L14.25 11.25', 'M4.5,7.875a.375.375,0,1,1-.375.375A.374.374,0,0,1,4.5,7.875', 'M10.5,7.875a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M7.5,18.75a2.25,2.25,0,0,1,0-4.5h8.646a14.954,14.954,0,0,1,6.69,1.579.75.75,0,0,1,0,1.341,14.955,14.955,0,0,1-6.69,1.58Z']],
  LockNetwork: ['lock-network', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.750 3.000 A2.250 2.250 0 1 0 23.250 3.000 A2.250 2.250 0 1 0 18.750 3.000 Z', 'M18.750 12.000 A2.250 2.250 0 1 0 23.250 12.000 A2.250 2.250 0 1 0 18.750 12.000 Z', 'M14.25 12L18.75 12', 'M14.25 7.5L19.132 4.253', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M14.25 16.5L19.132 19.746', 'M0.750 9.750 L11.250 9.750 L11.250 17.250 L0.750 17.250 Z', 'M6,13.125a.375.375,0,1,0,.375.375A.374.374,0,0,0,6,13.125H6', 'M2.25,9.75V7.5a3.75,3.75,0,0,1,7.5,0V9.75']],
  KeyLock1: ['key-lock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 20.250 A3.000 3.000 0 1 0 6.750 20.250 A3.000 3.000 0 1 0 0.750 20.250 Z', 'M6.75 20.25L14.25 20.25 14.25 22.5', 'M11.25 20.25L11.25 21.75', 'M6.75,15V11.25a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5v10.5a1.5,1.5,0,0,1-1.5,1.5h-4.5', 'M9.75,9.75V6a5.25,5.25,0,0,1,10.5,0V9.75', 'M12.914,17.343a2.25,2.25,0,1,1,3.608.813']],
  KeyholeCircle: ['keyhole-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 9.750 A2.250 2.250 0 1 0 14.250 9.750 A2.250 2.250 0 1 0 9.750 9.750 Z', 'M12 12L12 16.5', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']]
};
exports["default"] = _default;